import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../shared/services/auth.service';
import { EgNavBarComponent } from '../../shared/components/eg-nav-bar/eg-nav-bar.component';
import { SharedApplicantService } from '../../shared/services/shared-applicant.service';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule,EgNavBarComponent],
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent {
  userEmail: string | null = '';
  userRole: string | null = '';
  constructor(private readonly http: HttpClient, private readonly router: Router, private readonly authService: AuthService, private readonly sharedApplicantService: SharedApplicantService) {}

  ngOnInit(): void {
    this.userEmail = localStorage.getItem('userEmail');
    this.sharedApplicantService.userRole$.subscribe((data) => {
      this.userRole = data;
      console.log('user role :', this.userRole);
    });
  }

//did not pass dynamic headers since we are not using our logout api any more
  logout() {
    const token = localStorage.getItem('authToken');
    if (token) {
      this.http.post('http://localhost:8080/api/v1/auth/logout', {}, {
        headers: { 'Authorization': `Bearer ${token}` }
      }).subscribe(
        () => {
          localStorage.removeItem('authToken');
          localStorage.removeItem('userEmail');
          this.router.navigate(['/']);
        },
        error => {
          console.error('Logout failed:', error);
        }
      );
    } else {
      this.router.navigate(['/']);
    }
  }

  startApplication(){
    this.router.navigate(['/applicant-list']);
  }
}
